<template>
  <b-form-group class="text-center" v-if="provider">

    <template v-if="isSainsburys && (provider.handle === 'sainsburys-prod-microsoft-ad' || provider.handle === 'sainsburys-dev-microsoft-ad')">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        {{ $t('auth.single-sign-on.sign-in-with-ext') }}
        <img class="ml-1" src="/cdn/1/106/20/assets/assets/sains-logo.png"/>
      </b-button>
      <i18n v-if="provider.identifiers" path="auth.single-sign-on.with-your-ext-identifiers" tag="b-form-text">
        <template v-slot:domains>
          <strong>{{ $tc('grammar.or-list', provider.identifiers.length, provider.identifiers) }}</strong>
        </template>
      </i18n>
    </template>
    <template v-else-if="isSainsburys && (provider.handle === 'argos-prod-microsoft-ad' || provider.handle === 'argos-dev-microsoft-ad')">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        {{ $t('auth.single-sign-on.sign-in-with-ext') }}
        <img class="ml-1" src="/cdn/1/40/20/assets/assets/argos-logo.png"/>
      </b-button>
      <i18n v-if="provider.identifiers" path="auth.single-sign-on.with-your-ext-identifiers" tag="b-form-text">
        <template v-slot:domains>
          <strong>{{ $tc('grammar.or-list', provider.identifiers.length, provider.identifiers) }}</strong>
        </template>
      </i18n>
    </template>
    <template v-else-if="isOcadoGroup && provider.handle === 'ocado-microsoft-ad'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="primary">
        {{ $t('auth.single-sign-on.sign-in-with-ext', { name: 'Ocado' }) }}
      </b-button>
      <i18n v-if="provider.identifiers" path="auth.single-sign-on.with-your-ext-identifiers" tag="b-form-text">
        <template v-slot:domains>
          <strong>{{ $tc('grammar.or-list', provider.identifiers.length, provider.identifiers) }}</strong>
        </template>
      </i18n>
    </template>

    <template v-else-if="provider.type === 'SAML'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        <font-awesome-icon v-if="icon" class="fa-icon" :icon="icon"/> {{ $t('auth.single-sign-on.sign-in-with-ext', { name }) }}
      </b-button>
      <i18n v-if="provider.identifiers" path="auth.single-sign-on.with-your-ext-identifiers" tag="b-form-text">
        <template v-slot:domains>
          <strong>{{ $tc('grammar.or-list', provider.identifiers.length, provider.identifiers) }}</strong>
        </template>
      </i18n>
    </template>

    <template v-else-if="provider.type === 'OIDC'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        <font-awesome-icon v-if="icon" class="fa-icon" :icon="icon"/> {{ $t('auth.single-sign-on.sign-in-with-ext', { name }) }}
      </b-button>
      <b-form-text v-if="provider.identifiers">
        <template v-slot:domains>
          <strong>{{ $tc('grammar.or-list', provider.identifiers.length, provider.identifiers) }}</strong>
        </template>
      </b-form-text>
    </template>

    <template v-else-if="provider.type === 'Google'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        <font-awesome-icon v-if="icon" class="fa-icon" :icon="icon"/> {{ $t('auth.single-sign-on.sign-in-with-google') }}
      </b-button>
      <b-form-text>{{ $t('auth.single-sign-on.with-your-google-social') }}</b-form-text>
    </template>

    <template v-else-if="provider.type === 'Facebook'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        <font-awesome-icon v-if="icon" class="fa-icon" :icon="icon"/> {{ $t('auth.single-sign-on.sign-in-with-facebook') }}
      </b-button>
      <b-form-text>{{ $t('auth.single-sign-on.with-your-facebook-social') }}</b-form-text>
    </template>

    <template v-else-if="provider.type === 'LoginWithAmazon'">
      <b-button class="single-sign-on" :class="classes" :href="provider.url" variant="transparent">
        <font-awesome-icon v-if="icon" class="fa-icon" :icon="icon"/> {{ $t('auth.single-sign-on.sign-in-with-amazon') }}
      </b-button>
      <b-form-text>{{ $t('auth.single-sign-on.with-your-amazon-social') }}</b-form-text>
    </template>

  </b-form-group>
</template>

<script>
import { createSingleSignOnButton } from '@src/lib/branding';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    name: null,
    icon: null,
    classes: null,
  }),
  created() {
    const { type, handle } = this.provider;
    const { name, icon, classes } = createSingleSignOnButton(type, handle);
    this.name = name || `${handle} ${type}`;
    this.icon = icon || null;
    this.classes = Array.isArray(classes) ? classes : [];

    if (name) {
      this.classes.push(`name-${name.toLowerCase()}`);
    }
    if (this.company && this.company.id) {
      this.classes.push(`client-${this.company.id}`);
    }
  },
  computed: {
    ...mapRoot([ 'company', 'isSainsburys', 'isOcadoGroup' ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/SingleSignOnButton.vue